module.exports = __webpack_public_path__ + "static/escaleras1-bw-f1114b58092cdc4709849a1742a22241.png";